import EventEmitter from "base/EventEmitter";
import debounce from "debounce";
import Ajax from "base/Ajax";
import {svg_include} from "index";
import GlobalEvents from "base/GlobalEvents";

export default class TrainingFilters extends EventEmitter {
    constructor($element) {
        super();
        this.$element = $element;

        this.$filters = this.$element.find('.js-filters');
        this.$content = this.$element.find('.js-content');
        this.$pagination = this.$element.find('.js-pagination');
        this.$showing_text = this.$element.find('.js-showing-text');

        this.category = this.$element.find('.js-category-id').val();

        this.request = null;

        this.dropdownBreakpoint = 1200;

        this.debouncedChange = debounce(this.updateLatestFilters.bind(this), 200);

        this.filters = this.getLatestFilters();
        this.updateStartingValues();

        this.lastFilters = $.extend({}, this.filters);

        this.bindEvents();
    }

    updateLatestFilters() {
        this.filters = this.getLatestFilters();
        this.updateClearButton();
        this.updateChangeNotifications();
        this.updateCountNotifications();
        this.scrollToTop();
    }

    updateClearButton() {
        if (this.getNumberOfAppliedFilters() > 0) {
            this.$element.find('.filter-section').addClass('has-values');
        } else {
            this.$element.find('.filter-section').removeClass('has-values');
        }
    }

    getNumberOfAppliedFilters() {
        return Object.keys(this.filters).length;
    }

    updateChangeNotifications() {
        let updated_fields = this.getUpdatedFields();

        this.$element.find('.js-accordion-dropdown-item').removeClass('has-changes');
        Object.keys(updated_fields).forEach((key) => {
            this.$element.find('js-accordion-dropdown-item[data-name="' + key + '"]').addClass('has-changes');
        });
    }

    updateCountNotifications() {
        let updated_count = this.getNotificationsCount();
        this.$element.find('.js-accordion-count').text('');
        this.$element.find('.js-accordion-dropdown-item').removeClass('has-checked');

        Object.keys(updated_count).forEach((key) => {
            let number = updated_count[key];

            if (number > 0) {
                this.$element.find('.js-accordion-dropdown-item[data-name="' + key + '"]').addClass('has-checked');
                this.$element.find('.js-accordion-dropdown-item[data-name="' + key + '"] .js-accordion-count').text(number);
            }
        });
    }

    getUpdatedFields() {
        let updated_fields = {};

        Object.keys(this.filters).forEach((key) => {

            if ('undefined' === typeof this.starting_filters[key]) {
                updated_fields[key] = true;
                return;
            }

            if (this.filters[key].length !== this.starting_filters[key].length) {
                updated_fields[key] = true;
                return;
            }

            Object.values(this.filters[key]).forEach((value) => {
                if (this.filters[key] instanceof Object) {
                    return;
                }

                if (this.starting_filters[key].indexOf(value) === -1) {
                    updated_fields[key] = true;
                    return;
                }
            });
        });

        Object.keys(this.starting_filters).forEach((key) => {
            if ('undefined' === typeof this.filters[key]) {
                updated_fields[key] = true;
                return;
            }
        });

        return updated_fields;
    }

    getNotificationsCount() {
        let field_count = {};

        Object.keys(this.filters).forEach((key) => {
            field_count[key] = this.filters[key].length;
        });

        return field_count;
    }

    updateStartingValues() {
        this.starting_filters = this.getLatestFilters();
    }

    getLatestFilters() {
        let filters = {};

        this.$element.find(".js-filter-value:checked").each((_, el) => {
            let $el = $(el);
            let name = $el.attr("data-name");

            if ('undefined' === typeof filters[name]) {
                filters[name] = [];
            }

            filters[name].push($el.attr("value"));
        });

        let search_val = this.$element.find(".js-search-input").val();
        if (search_val !== '') {
            filters['keyword'] = search_val;
        }

        return filters;
    }

    bindEvents() {
        let me = this;

        this.$element.on('click', '.js-show-filters', () => {
            this.open();
            return false;
        }).on('click', '.js-show-results', () => {
            this.updateResults();
            return false;
        }).on('change', '.js-filter-value', () => {
            this.updateLatestFilters();
            if ($(window).outerWidth() >= this.dropdownBreakpoint) {
                this.updateResults();
            }
            return false;
        }).on('click', '.js-clear', () => {
            this.clear();
            return false;
        }).on('change', '.js-search-input', () => {
            this.debouncedChange();
            return false;
        }).on('click', '.js-change-page', function () {
            let $this = $(this);

            me.scrollToTop();
            me.filters.page = parseInt($this.attr('data-page'));
            me.getCourses();

            return false;
        }).on('click', '.js-filter-search', () => {
            this.open();
            this.$element.find('.js-search-input').focus();
            return false;
        }).on('click', '.js-clear-section', function () {
            let $section = $(this).parents('.js-accordion-dropdown-item');
            let section = $section.attr('data-name');
            me.clearSection(section);

            if ($(window).outerWidth() >= me.dropdownBreakpoint) {
                me.updateResults();
            }
            return false;
        }).on('submit', '.js-search-form', () => {
            if ($(window).outerWidth() >= this.dropdownBreakpoint) {
                this.updateResults();
            }
            return false;
        }).on('click', '.js-accordion-dropdown-title', function () {
            let $parent = $(this).parents('.js-accordion-dropdown-item');
            let isOpen = $parent.is('.accordion--active');
            GlobalEvents.emit("popup-close");

            if (!isOpen) {
                $parent.addClass('accordion--active');
            }
        }).on("click", ".js-accordion-dropdown-item", (e) => {
            e.stopPropagation();
        });

        GlobalEvents.on('popup-close', () => {
            this.$element.find('.js-accordion-dropdown-item').removeClass('accordion--active');
        });
    }

    updateResults() {
        this.updateLatestFilters();
        this.close();
        this.getCourses();
    }

    checkFiltersHaveChanged() {

        if (this.filters.length !== this.lastFilters.length) {
            return true;
        }

        let updated_fields = this.compareFiltersForChanges(this.filters, this.lastFilters);

        if (updated_fields) {
            return true;
        }

        updated_fields = this.compareFiltersForChanges(this.lastFilters, this.filters);

        if (updated_fields) {
            return true;
        }

        return false;
    }

    compareFiltersForChanges(main, comparison) {

        let updated_fields = false;

        Object.keys(main).forEach((key) => {
            if (!(main[key] instanceof Object)) {

                if (main[key] !== comparison[key]) {
                    updated_fields = true;
                }

                return;
            }

            if ('undefined' == typeof comparison[key]) {
                updated_fields = true;
                return;
            }

            if (main[key].length !== comparison[key].length) {
                updated_fields = true;
                return;
            }

            if ('undefined' !== typeof main[key]['min'] && 'undefined' !== typeof main[key]['max']) {
                if (main[key]['min'] !== comparison[key]['min'] || main[key]['max'] !== comparison[key]['max']) {
                    updated_fields = true;
                }
                return;
            }

            Object.values(main[key]).forEach((value) => {
                if (main[key] instanceof Object) {
                    return;
                }

                if (main[key].indexOf(value) === -1) {
                    updated_fields = true;
                }
            });
        });

        return updated_fields;
    }

    getCourses() {
        if (!this.checkFiltersHaveChanged()) {
            return;
        }

        this.lastFilters = $.extend({}, this.filters);

        this.$content.addClass('loading');

        if (this.request !== null) {
            this.request.abort();
        }

        this.request = Ajax.get('wp/v2', 'training', $.extend({
            status: 'publish', 'training-category': [this.category],
        }, this.filters));

        try {
            let eventData = {
                "event": "training-search",
                "filters": $.extend({
                    status: 'publish', 'training-category': [this.category],
                }, this.filters)
            };
            dataLayer.push(eventData);
        } catch (e) {
            console.log(e);
        }

        this.request.then((data) => {
            this.request = null;

            let headers;

            if ('undefined' !== typeof data.headers) {
                headers = data.headers;
                delete data.headers;
            }

            if (data.length === 0) {
                this.showNoResults(headers);
            } else {
                this.updateCourseInformation(data, headers);
                this.updatePagination(data, headers);
            }

            this.$content.removeClass('loading');
        }).catch((e) => {
            this.request = null;
            console.trace(e);
            this.$content.removeClass('loading');
        });
    }

    updatePagination(data, headers) {
        this.buildPagination(data, headers);
        this.updateShowingText(headers);
    }

    clear() {
        this.$element.find(".js-filter-value:checkbox").prop('checked', false);
        this.$element.find("input[name=\"keywords\"]").val('');

        this.updateLatestFilters();
    }

    clearSection(section) {
        this.$element.find("[data-name='" + section + "'] .js-filter-value:checkbox").prop('checked', false);
        this.$element.find("[data-name='" + section + "'] input[name=\"keywords\"]").val('');

        this.updateLatestFilters();
    }


    open() {
        $('body').addClass('show-filters');
    }

    close() {
        $('body').removeClass('show-filters');
    }

    updateCourseInformation(data, headers) {
        this.$content.html(eotwJSXFactory('div', {className: "columns columns--courses"}, [
            data.map((value) => {
                return (eotwJSXFactory('div', {className: "columns__column"}, [
                    this.buildCourse(value)
                ]));
            })
        ]));
    }

    buildCourseTermList(terms) {
        if (terms.length <= 0) {
            return '';
        }

        let $list = (eotwJSXFactory('div'));
        Object.values(terms).forEach((value) => {
            $list.append(eotwJSXFactory('div', {className: "course-meta-item course-meta-item--card"}, [
                eotwJSXFactory('div', {className: "course-meta-item__icon", unsafeHtml: svg_include('tick')}),
                eotwJSXFactory('div', {className: "course-meta-item__text"}, [value])
            ]))
        });

        return $list;
    }

    buildCoursePrice(price) {
        if (price === '') {
            return '';
        }

        return (eotwJSXFactory('div', {className: "price"}, [
            eotwJSXFactory('strong', {unsafeHtml: price})," ", eotwJSXFactory('em', null, ["+ VAT"]),eotwJSXFactory('br'),
            "per attendee"
        ]));
    }

    buildCourseSnippet(snippet) {
        if (snippet === '') {
            return '';
        }

        let $content = (eotwJSXFactory('div', {unsafeHtml: snippet}));
        return $content.html();
    }

    buildCourseDuration(duration) {
        if (duration <= 0) {
            return '';
        }

        return (eotwJSXFactory('div', {className: "course-meta-item course-meta-item--card"}, [
            eotwJSXFactory('div', {className: "course-meta-item__icon", unsafeHtml: svg_include('duration')}),
            eotwJSXFactory('div', {className: "course-meta-item__text"}, ["Course duration: ", duration, " day", duration > 1 ? 's' : ''])
        ]));
    }

    buildCourseLevel(level) {
        if ('undefined' === typeof level.name) {
            return '';
        }

        return (eotwJSXFactory('div', {className: "course-meta-item course-meta-item--card"}, [
            eotwJSXFactory('div', {className: "course-meta-item__icon", unsafeHtml: svg_include('level')}),
            eotwJSXFactory('div', {className: "course-meta-item__text"}, [level.name, " Course"])
        ]));
    }

    buildCourse(data) {
        let information = 'undefined' === typeof data['information'] ? null : data['information'];
        if (information === null) {
            return;
        }

        let $list = 'undefined' === typeof information['additional_terms'] ? '' : this.buildCourseTermList(information['additional_terms']);
        let $price = 'undefined' === typeof information['price'] ? '' : this.buildCoursePrice(information['price']);
        let $snippet = 'undefined' === typeof information['snippet'] ? '' : this.buildCourseSnippet(information['snippet']);
        let $duration = 'undefined' === typeof information['duration'] ? '' : this.buildCourseDuration(information['duration']);
        let $level = 'undefined' === typeof information['level'] ? '' : this.buildCourseLevel(information['level']);

        let branding = 'undefined' === typeof information['branding'] ? false : information['branding'];

        return (eotwJSXFactory('div', {className: "card card--course branding--" + branding}, [
            eotwJSXFactory('div', {className: "card__heading"}, [
                branding ? (eotwJSXFactory('div', {className: "inline-logo inline-logo--course"}, [
                    eotwJSXFactory('img', {src: "/wp-content/themes/mills-cnc/images/svg/inline-logo--" + branding + ".svg", alt: branding})
                ])) : '',
                eotwJSXFactory('h2', {className: "heading heading--4"}, [eotwJSXFactory('a', {href: information.link, unsafeHtml: information.title})])
            ]),
            eotwJSXFactory('div', {className: "card__text", unsafeHtml: $snippet}),
            eotwJSXFactory('div', {className: "card__sidebar"}, [
                eotwJSXFactory('h3', {className: "heading heading--6"}, ["Details"]),
                $level,
                $duration,
                $list
            ]),
            eotwJSXFactory('div', {className: "card__prices"}, [
                $price,
                eotwJSXFactory('a', {href: information.link, className: "link link--course"}, [
                    eotwJSXFactory('span', {className: "link__text"}, ["View course details"]),
                    eotwJSXFactory('span', {className: "link__arrow", unsafeHtml: svg_include('btn-arrow')})
                ])
            ])
        ]));
    }

    showNoResults(headers) {
        this.$content.html(this.buildNoResults());
        this.$pagination.html('');
        this.updateShowingText(headers);
    }

    buildNoResults() {
        return (eotwJSXFactory('div', {className: "no-results"}, [
            eotwJSXFactory('div', {className: "no-results__icon", unsafeHtml: svg_include('no-results-search')}),
            eotwJSXFactory('div', {className: "no-results__content"}, [
                eotwJSXFactory('h2', {className: "heading"}, ["Sorry, no courses match your filters"]),
                eotwJSXFactory('p', null, ["Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."])
            ])
        ]));
    }

    updateShowingText(headers) {
        let page = 'undefined' === typeof this.filters.page ? 1 : this.filters.page;

        let total_results = 'undefined' === typeof headers['x-wp-total'] ? 0 : parseInt(headers['x-wp-total']);

        let start = Math.min(total_results, ((page - 1) * 18) + 1);
        let end = Math.min(total_results, (start - 1 + 18));

        let text = 'Showing <strong>' + start + '-' + end + '</strong> of ' + total_results + ' courses';

        if ('undefined' !== typeof this.filters.keyword && this.filters.keyword !== '') {
            text += ' <strong>(SEARCH TERMS: "' + this.filters.keyword + '")</strong>';
        }

        this.$showing_text.html(text);
    }

    buildPagination(data, headers) {
        this.$pagination.html('');

        if ('undefined' === typeof headers['x-wp-totalpages']) {
            return;
        }

        let total_pages = parseInt(headers['x-wp-totalpages']);

        if (total_pages <= 1) {
            return;
        }

        let total_results = 'undefined' === typeof headers['x-wp-total'] ? 0 : parseInt(headers['x-wp-total']);

        let page = 'undefined' === typeof this.filters.page ? 1 : this.filters.page;

        let range = 2;
        let show_items = 5;

        let base = window.location.pathname;

        let $pagination = (eotwJSXFactory('div', {className: "pagination"}));
        let $wrap = (eotwJSXFactory('div', {className: "pagination__wrap"}));

        if (page > 1) {
            $wrap.append(eotwJSXFactory('a', {href: this.getPageLink(base, page - 1), 'data-page': page - 1, className: "pagination__arrow pagination__arrow--prev js-change-page", unsafeHtml: svg_include('chevron')}));
        }

        let $list = (eotwJSXFactory('ol', {className: "pagination__list"}));

        for (let i = 1; i <= total_pages; i++) {
            if (1 !== total_pages && (!(i >= page + range + 1 || i <= page - range - 1) || total_pages <= show_items)) {
                $list.append(eotwJSXFactory('li', {className: "pagination__item"}, [
                    page === i ? (eotwJSXFactory('span', {className: "pagination__link pagination__link--active"}, [i])) : (eotwJSXFactory('a', {href: this.getPageLink(base, i), 'data-page': i, className: "pagination__link js-change-page"}, [i]))
                ]));
            }
        }

        $wrap.append($list);

        if (page < total_pages) {
            $wrap.append(eotwJSXFactory('a', {href: this.getPageLink(base, page + 1), 'data-page': page + 1, className: "pagination__arrow js-change-page", unsafeHtml: (svg_include('chevron'))}),);
        }

        $pagination.append($wrap);

        let start = ((page - 1) * 20) + 1;
        let end = Math.min(total_results, (start - 1 + 20));

        $pagination.append(eotwJSXFactory('div', {class: "pagination__results"}, [
            eotwJSXFactory('p', null, ["Showing ", eotwJSXFactory('strong', null, [start, "-", end])," of ", total_results, " courses"])
        ]));

        this.$pagination.html($pagination);
    }

    scrollToTop() {
        $('html, body').animate({
            scrollTop: this.$element.offset().top - 50
        }, 500);
    }

    getPageLink(base, i) {
        let link = base;

        if (i > 1) {
            link += 'page/' + i + '/';
        }

        return link;
    }
}